import DownloadResume from "./DownloadResume"
const AboutMe = () => {
  return (
    <section>
      <h2 className="title-font pink-text h2-tag">About Me</h2>
      <p className="white-text p-tag">
        A full-stack-developer as a beginner role to enhance and explore my technical knowledge
         I enjoy creating beautiful, accessible, and
        responsive websites using HTML, CSS, Sass, node.js, Express.js
        JavaScript, and React. Effective use of time, problem-solving, and
        communication skills help me show a positive attitude in complex
        situations, and my desire to learn quickly adapts me to changing
        situations.
      </p>
      <DownloadResume/>
    </section>
      
  );
};
export default AboutMe;
